import { createSelector } from '@ngrx/store';

import { HomeProject } from '@models/swagger';
import { State } from './reducer';
import { selectPostProjectState } from '../selectors';

export const getData = createSelector(selectPostProjectState, (state: State) => state.data);

export const getError = createSelector(selectPostProjectState, (state: State) => state.error);

export const getLoading = createSelector(selectPostProjectState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: HomeProject) => T) =>
  createSelector(selectPostProjectState, (state: State) => fn(state.data));
